import { render, staticRenderFns } from "./notes-universal.vue?vue&type=template&id=1e95beee&scoped=true"
import script from "./notes-universal.vue?vue&type=script&lang=ts"
export * from "./notes-universal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e95beee",
  null
  
)

export default component.exports